import { PageHeader } from '@core/components/PageHeader';
import { SearchBar } from '@core/components/SearchBar';
import { useApiUtils } from '@core/util/apiUtils';
import * as Actions from 'app/store/actions';
import Tour from '@core/components/Tour';
import FusePageCarded from '@fuse/core/FusePageCarded';
import { Button } from '@material-ui/core';
import { usuarioApi } from 'app/services/api/usuarioApi';
import { GlobalContext } from 'app/store/globalcontext';
import { initializeReactGA } from 'app/utils/analyticsUtil';
import React, { useContext, useEffect, useState } from 'react';
import { FaFileContract } from 'react-icons/fa';
import { useHistory } from 'react-router';
import {
  ContratoBuscaAvancadaModal,
  ContratoCadastroModal,
  ContratoPendenciasModal,
  ContratoRescisaoModal,
  ContratoTable,
  ContratoVisualizacaoModal,
} from './components';
import { steps } from './components/steps/steps';
import { ContratoAction, ContratoProvider, useContrato } from './store';
import { contratosStyles } from './styles';

const ContratosBusca = () => {
  const [state, dispatch] = useContrato();

  const styles = contratosStyles();

  const onChangeSearch = (value) => {
    dispatch(ContratoAction.setPesquisar(value));
  };

  return (
    <PageHeader title="Contratos" icon={<FaFileContract />}>
      <div className={styles.searchBarContainer}>
        <div className="flex items-center w-full max-w-512 stepBarraPesquisa">
          <SearchBar
            searchText={state.search}
            onChange={onChangeSearch}
            placeholder="Pesquise pelo cliente, identificador ou valor"
          />
        </div>

        <div className="stepBuscaAvancada">
          <div className={styles.searchBarContainer}>
            <Button
              className={styles.link}
              onClick={() => {
                dispatch(ContratoAction.buscaAvancada());
              }}
            >
              Busca avançada
            </Button>
          </div>
        </div>
      </div>
    </PageHeader>
  );
};

const ContratoContent = () => {
  const history = useHistory();
  const [state, dispatch] = useContrato();
  const apiUtils = useApiUtils(dispatch, Actions);

  const [run, setRun] = useState(false);
  const [tour, setTour] = useState(false);
  const [, setLoading] = useState(false);

  const [funcionalidadesTour, setFuncionalidadesTour] = useContext(GlobalContext).funcionalidadesTour;

  useEffect(() => {
    initializeReactGA(history?.location?.pathname);
    if (!funcionalidadesTour) {
      setFuncionalidadesTour([]);
    }
    onFetchData(state.requestParams);
    // Efeito de montagem: roda uma única vez. Incluir as dependências reexecutaria a carga
    // inicial a cada render (loop de chamadas à API).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onFetchData = (params) => {
    const funcionalidadeJaExistente = funcionalidadesTour?.some((e) => e === 'CONTRATOS');
    if (!funcionalidadeJaExistente) {
      setRun(true);
      setTour(true);
      ContratoAction.buscarTour(dispatch);
    } else {
      ContratoAction.carregarRegistros(dispatch, params, state.filtroAvancado);
    }
  };

  const atualizarTour = async () => {
    try {
      setLoading(true);
      funcionalidadesTour.push('CONTRATOS');
      await usuarioApi.updateTour(funcionalidadesTour);
      setRun(false);
      setTour(false);
      setFuncionalidadesTour(funcionalidadesTour);
      onFetchData(state.requestParams);
    } catch (err) {
      apiUtils.handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <FusePageCarded
      innerScroll
      header={<ContratosBusca />}
      content={
        <>
          <Tour steps={steps} run={run} setRun={setRun} onFinish={() => atualizarTour()} disableScrolling={true} />
          <ContratoTable onTour={tour} onFetchData={onFetchData} />
          <ContratoBuscaAvancadaModal />
          <ContratoCadastroModal />
          <ContratoVisualizacaoModal />
          <ContratoRescisaoModal />
          <ContratoPendenciasModal />
        </>
      }
    />
  );
};

const Contrato = () => {
  return (
    <ContratoProvider>
      <ContratoContent />
    </ContratoProvider>
  );
};

export default Contrato;
